<template>
	<div class="bottom-navigation">
		<router-link v-for="route in routes"
					 :key="route.path"
					 class="bottom-nav-item"
					 :to="route.path"
		>
			<img class="icon_active" :src="route.icon_active" alt="">
			<img class="icon" :src="route.icon" alt="">
			{{_(route.name)}}
		</router-link>
	</div>
</template>

<script>
	export default {
		name: "BottomNavigation",
		props: {
			routes: {type: Array, default: () => []}
		},
	}
</script>

